/** Video feed variants that can be opened in the video player modal. */
export const VIDEO_FEED_TYPE = {
  BROADCAST: '',
  SCOUTING: 'scouting',
} as const;

/** Sub-folder that holds the wide-angle (scouting) clips: `<baseUrlVideo>/wide-angle/<gameId>.mp4`. */
export const WIDE_ANGLE_SUBFOLDER = 'wide-angle';

/** The selectable clip views exposed by the action toolbar (TV / wide-angle / 2D field). */
export const FEED_VIEW = {
  BROADCAST: 'tv',
  SCOUTING: 'scouting',
  FIELD: '2d',
} as const;

export type FeedView = (typeof FEED_VIEW)[keyof typeof FEED_VIEW];
